export default __webpack_public_path__ + "static/media/brown-1.24723c66.png";